import * as React from 'react';
import Notification from './Notification.jsx';
import axios from 'axios';
import './NotificationsContainer.scss';
export default class NotificationsContainer extends React.Component {
    constructor(props) {
        super(props);
        
        AUTH.messages = typeof AUTH.messages=="string"? JSON.parse(AUTH.messages): AUTH.messages;

        let nb_by_type = {
            actions: AUTH.messages.actions ? Object.keys(AUTH.messages.actions).length : 0,
            messages: AUTH.messages.messages ? Object.keys(AUTH.messages.messages).length : 0,
            news: AUTH.messages.messages ? Object.keys(AUTH.messages.news).length : 0,
        };

        let active_tab;
        if(['hotelier', 'centraldesk'].includes(AUTH.messages.as)) {
            this.types_motifs = {
                'actions': {
                    'label': this.props.trad.a_faire,
                },
                'messages': {
                    'label': this.props.trad.messages,
                },
                'news': {
                    'label': this.props.trad.quoi_de_neuf,
                },
            };
            active_tab = 'actions';
        } else {
            this.types_motifs = {
                'news': {
                    'label': this.props.trad.quoi_de_neuf,
                },
                'messages': {
                    'label': this.props.trad.messages,
                },
            }
            active_tab = 'news';
        }
        
        this.state = {
            isLoaded: false,
            displayed: false,
            actions: AUTH.messages.actions,
            nb_by_type: nb_by_type,
            messages: AUTH.messages.messages,
            news: AUTH.messages.news,
            active_tab: active_tab,
            nb_notifications: nb_by_type.actions + nb_by_type.messages + nb_by_type.news,
            frontloginas: AUTH.messages.as,
            nbTasksTodo: 0
        };

        this.wrapperRef = React.createRef();
        this.handleClickOutside = this.handleClickOutside.bind(this);
    }

    componentDidMount() {
        document.addEventListener("mousedown", this.handleClickOutside);
        if(!AUTH.mercure_disabled) {
            GLOBAL_NAV.add_mercure_event(
                'global', 
                '/myspace/'+AUTH.membres_id+'/'+AUTH.hash, 
                (e) => {
                    const data = JSON.parse(e.data);
                    switch(data.type) {
                        case 'notifications':
                            this.setState({
                                actions: data.actions,
                                messages: data.messages,
                                news: data.news
                            }, () => this.recalc());
                            break;
                            
                        case 'tasks':
                            this.getCurrentMembreTotalTasksTodo()
                            break;
                    }

                }
            );

            if(this.props.backyoupay == 1) {
                GLOBAL_NAV.add_mercure_event(
                    'global',
                    '/not_complete_breakdown/' + currentSocieteId,
                    () => this.getNotCompleteBreakdown()
                );
            }

        }
        
        if(this.props.tasks == 1) {
            this.getCurrentMembreTotalTasksTodo();
        }
        if(this.props.backyoupay == 1) {
            this.getNotCompleteBreakdown();
        }
    }
    
    componentWillUnmount() {
        document.removeEventListener("mousedown", this.handleClickOutside);
    }
    

    handleClickIcon = (id, type) => {
        if(type == 'news'){
            this.handleDeleteNotification(id)            
        }

        this.setState({
            displayed: !this.state.displayed
        });
    }

    handleClickTab = (type) => {
        this.setState({
            active_tab: type
        });
    }

    handleClickOutside(event) {
        if (this.state.displayed && this.wrapperRef && !this.wrapperRef.current.contains(event.target)) {
            this.setState({
                displayed: false
            });
        }
    }

    handleDeleteNotification = (id) => {
        const params = new URLSearchParams();
        params.append('id', id);

        fetch(ENV.base_lang_url + 'myspace/'+ (['hotelier', 'centraldesk'].includes(this.state.frontloginas) ? 'providers' : 'clients') +'//notifications/ajax/delete', {
            method: 'POST',
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
            body: params.toString()
        })
        .then(rtn => rtn.json())
        .then(result => {
            let notifs = {...this.state[this.state.active_tab]};
            let notifs_filtered = Object.fromEntries(Object.entries(notifs).filter(([key, notif]) => notif.id != id));
            this.setState({
                [this.state.active_tab]: notifs_filtered
            }, () => this.recalc());
        });
    }

    recalc() {
        let nb_by_type = {
            actions: Object.keys(this.state.actions).length,
            messages: Object.keys(this.state.messages).length,
            news: Object.keys(this.state.news).length,
        };
        this.setState({
            nb_by_type: nb_by_type,
            nb_notifications: nb_by_type.actions + nb_by_type.messages + nb_by_type.news,
        });
    }


    getCurrentMembreTotalTasksTodo = async (e) => {
        
        try {
            axios.get(
                ENV.base_lang_url + "myspace/providers//ajaxGetter/get_current_membre_total_tasks_todo"
            ).then(result => {
                this.setState({
                    isLoaded: true,
                    nbTasksTodo: result.data
                })
            });
        } catch (error) {
            this.setState({
                isLoaded: false,
                error
            });
        }
            
    }

    getNotCompleteBreakdown = async (e) => {
        try {
            const result = await axios.get(
                ENV.base_lang_url + "myspace/providers//ajaxGetter/get_not_complete_breakdown"
            )
            if ( parseFloat(result.data) > 0 ) {
                $('.left_menu .breakdown-alert').addClass('text-gc-orange');
            } 
            else {
                $('.left_menu .breakdown-alert').removeClass('text-gc-orange');
            }
            
        } catch (error) {
        }
    }

    
    render() {

        return (

            <div className="all_notifications d-flex align-items-center">
				<div className="mr-3">
                    <div className="notifications-container" ref={this.wrapperRef}>
                    <button className="btn btn-gc-light-blue-dark rounded-pill position-relative d-block" 
                        type="button"
                        onClick={this.handleClickIcon}
                    >
                        <i className="fa-regular fa-bell"></i>
                        {this.state.nb_notifications > 0 &&
                            <span className="MercureNotificationsBadge">
                                <span className="badge badge-top badge-pill badge-gc-orange">
                                    {this.state.nb_notifications}
                                </span>		
                            </span>
                        }
                    </button>
                    
                    
                    <div className={"dropdown-menu dropdown-menu-right small notifications-encart" + (this.state.displayed ? ' d-block' : '')}>
                        <div className="px-4 py-2">
                            <h2 className="h5 text-gc-dark-blue font-weight-bold">{this.props.trad.notifications}</h2>
                        </div>
                        

                        <ul className="nav text-gc-dark-blue px-4" id="notificationsTab" role="tablist">

                            {
                                Object.keys(this.types_motifs).map((type) =>
                                    <li className="nav-item" key={type}>
                                        <button 
                                            className={"nav-link text-gc-dark-blue mr-3 "+ (this.state.active_tab == type ? 'active' : '')}
                                            id={type+"-tab"}
                                            data-target={"#notificationsTab_"+type}
                                            data-toggle="tab"
                                            type="button" 
                                            role="tab" 
                                            aria-controls={"notificationsTab_"+type} 
                                            aria-selected="true"
                                            onClick={() => this.handleClickTab(type)}
                                        >
                                            {this.types_motifs[type].label}
                                            <span className={"ml-1 badge badge-top badge-pill text-white "+ (this.state.active_tab == type ? 'badge-gc-orange' : 'badge-gc-gray')}>{this.state.nb_by_type[type]}</span>
                                        </button>
                                    </li>
                                )
                            }

                        </ul>

                        <div className="tab-content border-top" id="notificationsEncartTabContent">
                        {
                            Object.keys(this.types_motifs).map((type) =>
                            <div
                                className={"notificationsTab_"+type+" tab-pane fade "+(this.state.active_tab == type ? 'active show' : '')} 
                                id={"notificationsTab_"+type} 
                                role="tabpanel" 
                                aria-labelledby={type+"-tab"}
                                key={type}
                            >
                                {this.state.nb_by_type[type] > 0 ? (
                                    <table className="dropdown-table w-100 notificationsTable">
                                        <tbody>
                                        {
                                            Object.entries(this.state[type]).map(([key, notification])=> 
                                                <Notification 
                                                    notification={notification}
                                                    onClick={this.handleClickIcon}
                                                    onDelete={this.handleDeleteNotification}
                                                    key={key}
                                                    type={type}
                                                >
                                                </Notification>
                                            ) 
                                        } 
                                        </tbody>
                                    </table>
                                    )
                                    : 
                                    <p className="text-gc-dark-blue text-center pt-4 empty">
                                        {this.props.trad.aucune_notification}
                                    </p>
                                }
                                
                            </div>
                        )}
                        </div>
                        </div>
                    </div>
                </div>
				{this.props.tasks == 1 && <div className="mr-3 mr-md-4">
                    <a 
                        href="#"
                        data-target="providers//tasks_controller/index"
                        data-part="+"
                        className="btn btn-gc-light-blue-dark rounded-pill position-relative d-block get_part_link dynamic_base_link js-nav"
                    >
                        <i className="fa-regular fa-list-check"></i>
                        {this.state.nbTasksTodo > 0 && <span className="badge badge-top badge-pill badge-gc-orange">{this.state.nbTasksTodo}</span>}
                    </a>
                </div>}
			</div>


            
        );
    }
}

NotificationsContainer.defaultProps = {
    trad: TRAD.NotificationsContainer ?? {}
};